<template>
  <div class="tile-button position-relative">
    <div class="overlay">
      <TextPlaceholder
        variant="h4"
        :size="isMobile ? 'medium' : 'large'"/>
      <TextPlaceholder
        variant="small-text"
        :size="isMobile ? 'medium' : 'large'"/>
    </div>
  </div>
</template>

<script setup>
import TextPlaceholder from '@/components/global/sequin/TextPlaceholder.vue'
</script>

<style lang="scss" scoped>
@import './ImageTileButton.scss';

.tile-button {
  @include placeholder-loading-animation;

  .overlay {
    background-color: rgb($armor, 0.1);
  }
}
</style>
